// @flow
/* eslint-disable no-console */
import parseApiErrors from '@rover/utilities/parseApiErrors';
import type { Untranslated } from '@rover/shared/js/types';
import type { ApiErrorResponse } from '@rover/react-lib/types';

import APIError from './APIError';

type ParsedErrors = Array<string>;

const DefaultAPIErrorHandler = (
  error: ApiErrorResponse | Error, // If the error happens during the API call, we'll get an ApiErrorResponse, if it happens in code, we'll get a generic Error
  defaultErrorMessage: Untranslated = 'There was an error.'
) => {
  if (!error.response) throw error; // Generic Error, so no processing is necessary

  // $FlowFixMe
  const { response } = error;
  const errors: ParsedErrors = parseApiErrors(response);
  const message: Untranslated = errors.length ? errors.pop() : defaultErrorMessage;

  // FE-3685 Don't console.error during jest tests, it is noisy.
  if (!process.env.JEST_WORKER_ID) {
    console.error(
      // $FlowFixMe
      `Error in DefaultAPIErrorHandler: STATUS: ${response.status}, MESSAGE: ${
        typeof message === 'string' ? message : message.id
      }`
    );
  }

  // $FlowFixMe
  throw new APIError(message, response.status); // we throw the Error so that a duck can catch it and handle it
};

export default DefaultAPIErrorHandler;



// WEBPACK FOOTER //
// ../react-lib/src/apis/DefaultAPIErrorHandler.js